// pages/SearchAdmin.jsx
import React, { useState, useEffect } from 'react';
import SearchWidget from '../components/SearchWidget';
import axios from "axios";
import config from '../config/config';

const SearchAdmin = () => {
  const [activeDesign, setActiveDesign] = useState('design2');
  const [placeholder, setPlaceholder] = useState('Search products, brands, categories...');
  const [devMode, setDevMode] = useState(false);
  const [background, setBackground] = useState('');
  const [textColor, setTextColor] = useState('');

  const [previewOpen, setPreviewOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
 const [selectedVariants,setSelectedV]=useState([]);
  const token = localStorage.getItem("token");



  useEffect(() => {
    const load = async () => {
      if (!token) return setLoading(false);

      try {
        setLoading(true);
        await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

        const res = await axios.get(config.API_URL + '/api/pullSearchSettings', {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        });

        const db = res.data.searchSettings || {};

        setActiveDesign(db.activeDesign || 'design2');
        setPlaceholder(db.placeholder || 'Search products, brands, categories...');
        setDevMode(db.devMode || false);

        const styles = db.customStyles || {};
        setBackground(styles.background || '');
        setTextColor(styles.textColor || '');
      } catch (err) {
        console.error("Load failed:", err);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [token]);

  const currentConfig = {
    activeDesign,
    placeholder,
    devMode,
    customStyles: { background, textColor },
  };

  const save = async () => {
    try {
      setSaving(true);
      await axios.get(config.API_URL + "/sanctum/csrf-cookie", { withCredentials: true });

      const xsrf = document.cookie.split('; ').find(r => r.startsWith('XSRF-TOKEN='))?.split('=')[1];

      await axios.post(config.API_URL + "/api/saveSearchSettings", {
        settings: currentConfig
      }, {
        headers: {
          "Content-Type": "application/json",
          "X-XSRF-TOKEN": decodeURIComponent(xsrf || ''),
        },
        withCredentials: true,
      });

      alert("Search settings saved! 🎉");
    } catch (err) {
      alert("Save failed.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;

  return (
    <div className="min-h-screen bg-gray-100 flex">
      <div className="flex-1 p-8">
        <h1 className="text-3xl font-bold mb-8">Search Widget Editor</h1>

        <div className="mb-8">
          <h2 className="text-xl font-semibold mb-4">Choose Design</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {[
              { value: 'design1', label: 'Full Screen Overlay' },
              { value: 'design2', label: 'Dropdown Panel' },
              { value: 'design3', label: 'Compact Modal' },
            ].map(d => (
              <button
                key={d.value}
                onClick={() => setActiveDesign(d.value)}
                className={`p-6 border-2 rounded-xl text-left transition-all ${
                  activeDesign === d.value ? 'border-blue-500 bg-blue-50 shadow-md' : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <h3 className="font-medium text-lg">{d.label}</h3>
              </button>
            ))}
          </div>
        </div>

        <div className="space-y-6 mb-8">
          <div>
            <label className="block font-medium mb-2">Search Placeholder</label>
            <input
              value={placeholder}
              onChange={e => setPlaceholder(e.target.value)}
              className="w-full p-3 border rounded-lg"
              placeholder="Search products..."
            />
          </div>

          <div className="bg-yellow-50 p-5 rounded-xl border border-yellow-200">
            <div className="flex justify-between items-center mb-4">
              <h3 className="font-semibold">Dev Mode - Custom Styling</h3>
              <button
                onClick={() => setDevMode(!devMode)}
                className={`w-11 h-6 rounded-full relative ${devMode ? 'bg-yellow-600' : 'bg-gray-300'}`}
              >
                <span className={`absolute w-4 h-4 bg-white rounded-full transition ${devMode ? 'translate-x-6' : 'translate-x-1'}`} />
              </button>
            </div>

            {devMode && (
              <div className="space-y-4">
                <input value={background} onChange={e => setBackground(e.target.value)} placeholder="Background" className="w-full p-3 border rounded" />
                <input value={textColor} onChange={e => setTextColor(e.target.value)} placeholder="Text Color" className="w-full p-3 border rounded" />
              </div>
            )}
          </div>
        </div>

        <button
          onClick={() => setPreviewOpen(true)}
          className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700"
        >
          Preview Selected Design
        </button>

        <button
          onClick={save}
          disabled={saving}
          className="ml-4 bg-green-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-green-700 disabled:opacity-60"
        >
          {saving ? 'Saving...' : 'Save Settings'}
        </button>
      </div>

      {previewOpen && (
        <SearchWidget
          isOpen={previewOpen}
          onClose={() => setPreviewOpen(false)}
          config={currentConfig}
        />
      )}
    </div>
  );
};

export default SearchAdmin;